

import {PropType} from "vue";
import {LegalMention} from "../models/LegalMention";
import LinkFoldUnFold from "../../common/components/ob1/LinkFoldUnfold.vue";

export default {
    name: "LegalMentions",
    components: {LinkFoldUnFold},
    props: {
        legalMentions: {
            type: Array as PropType<LegalMention[]>,
            required: true
        },
    },
    computed: {
        title(): string {
            const titles: string[] = this.legalMentions
                .map((legalMention: LegalMention): string => legalMention.title)
                .filter((legalMentionTitle: string): boolean => !!legalMentionTitle);

            if (titles.length === 0) {
                return "Conditions";
            }

            return titles.join(" et ");
        }
    }
}
